import * as yup from "yup";

export const DocsSchema = yup.object().shape({
  title: yup.string().transform((value) => value?.trim()).max(225, "Title cannot exceed 225 characters").required("This field is required"),
  description: yup.string().transform((value) => value?.trim()).required("This field is required"),
  url: yup.string().transform((value) => value?.trim()).required("This field is required"),
  projectId: yup.number().transform((value, originalValue) => { return originalValue === "" || originalValue === null ? 0 : value; }).moreThan(0, "Project is required").required("Project is required"),
  type: yup.number().transform((value, originalValue) => { return originalValue === "" || originalValue === null ? 0 : value; }).moreThan(0, "Type is required").required("Type is required"),
});

export interface IDocsForm {
  title: string;
  description: string;
  url: string;
  projectId: number;
  type: number;
}